/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { _ as _typeof } from '../_chunks/dep-248ede8a.js';
import { forwardRef, useMemo, useEffect, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';
import { canUseDocument } from '../_util/dom.js';
import useConfig from '../hooks/useConfig.js';
import 'raf';
import 'lodash-es';
import '../_util/easing.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-8bcc0e9b.js';
import '../_chunks/dep-6b7c7d34.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-35c2a089.js';
import '../_chunks/dep-fad4e87b.js';
import 'dayjs';
import '../_chunks/dep-81c9c3a2.js';
import '../_common/js/global-config/default-config.js';

function getAttach(attach, triggerNode) {
  if (!canUseDocument) return null;
  var el;
  if (typeof attach === "string") {
    el = document.querySelector(attach);
  }
  if (typeof attach === "function") {
    el = attach(triggerNode);
  }
  if (_typeof(attach) === "object" && attach instanceof window.HTMLElement) {
    el = attach;
  }
  if (el && el.nodeType === 1) return el;
  return document.body;
}
var Portal = /*#__PURE__*/forwardRef(function (props, ref) {
  var attach = props.attach,
    children = props.children,
    triggerNode = props.triggerNode;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var container = useMemo(function () {
    if (!canUseDocument) return null;
    var el = document.createElement("div");
    el.className = "".concat(classPrefix, "-portal-wrapper");
    return el;
  }, [classPrefix]);
  useEffect(function () {
    var _parentElement$append;
    var parentElement = getAttach(attach, triggerNode);
    parentElement === null || parentElement === void 0 || (_parentElement$append = parentElement.appendChild) === null || _parentElement$append === void 0 || _parentElement$append.call(parentElement, container);
    return function () {
      var _parentElement$remove;
      parentElement === null || parentElement === void 0 || (_parentElement$remove = parentElement.removeChild) === null || _parentElement$remove === void 0 || _parentElement$remove.call(parentElement, container);
    };
  }, [container, attach, triggerNode]);
  useImperativeHandle(ref, function () {
    return container;
  });
  return canUseDocument ? /*#__PURE__*/createPortal(children, container) : null;
});
Portal.displayName = "Portal";

export { Portal as default, getAttach };
//# sourceMappingURL=Portal.js.map
